var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1996 9.49961L10.2908 16.4084C9.336 17.3632 8.04104 17.8996 6.69078 17.8996C3.879 17.8996 1.59961 15.6202 1.59961 12.8084C1.59961 11.4582 2.136 10.1632 3.09078 9.20844L10.2055 2.09372C10.842 1.4572 11.7053 1.09961 12.6055 1.09961C14.48 1.09961 15.9996 2.61921 15.9996 4.49372C15.9996 5.3939 15.642 6.2572 15.0055 6.89372L8.09666 13.8026C7.77841 14.1208 7.34675 14.2996 6.89667 14.2996C5.95941 14.2996 5.19961 13.5398 5.19961 12.6026C5.19961 12.1525 5.37841 11.7208 5.69667 11.4026L12.3996 4.69961",
    stroke: "#006AED",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardStack);
export default __webpack_public_path__ + "static/media/card-stack.bf5140378c94f27a692a5c4f7b5715ce.svg";
export { ForwardRef as ReactComponent };